// extracted by mini-css-extract-plugin
module.exports = {"title":"ChooseChapter_title__3qnQb","list":"ChooseChapter_list__2XIo7"};